import VueRouter from 'vue-router'
import Vue from 'vue';

import Step from '../components/Step';

Vue.use(VueRouter)

let router = new VueRouter({
    mode: 'history',
    base: '/book',
    routes: [
        // { path: '/', component: Services, name: 'services' },
        { path: '/', component: Step, name: 'home' },
        { path: '/step/:step', component: Step, name: 'step' },
        // { path: '/personal', component: Personal, name: 'personal'}
    ]
});

export default router